import type { AuthProvider } from 'react-admin';
import { accessProvider } from '@/access';

/**
 * Adapts the access-provider seam (`src/access`) to react-admin's
 * `AuthProvider` contract. There is no local login form: `login` is never
 * invoked because no `LoginPage` is mounted (see `src/App.tsx`) — the
 * active access provider resolves the principal from its own configuration
 * (build-time env locally; the corporate session once the federated
 * provider lands).
 */
export const authProvider: AuthProvider = {
  async login() {
    return Promise.reject(new Error('No existe un formulario de acceso local en esta aplicación.'));
  },

  async logout() {
    await accessProvider.endSession();
  },

  async checkAuth() {
    const principal = await accessProvider.resolvePrincipal();
    if (!principal) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  async checkError(error) {
    const status = (error as { status?: number } | undefined)?.status;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  async getIdentity() {
    const principal = await accessProvider.resolvePrincipal();
    if (!principal) {
      return Promise.reject();
    }
    return { id: principal.id, fullName: principal.displayName };
  },

  async getPermissions() {
    const principal = await accessProvider.resolvePrincipal();
    return principal?.roles ?? [];
  },
};
